let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6V2EZ")).then(() => parcelRequire('khYFw'));